(function () {
  'use strict';

  if (window.__cartTermsInit) return;
  window.__cartTermsInit = true;

  function getScope(target) {
    if (!target) return document;
    return target.closest('cart-drawer, .shopify-section--main-cart') || document;
  }

  function showError(scope) {
    var error = scope.querySelector('[data-cart-terms-error]');
    if (error) {
      error.style.display = 'block';
    }
  }

  function hideError(scope) {
    var error = scope.querySelector('[data-cart-terms-error]');
    if (error) {
      error.style.display = 'none';
    }
  }

  function blockIfUnchecked(e, target) {
    var scope = getScope(target || e.target);
    var checkbox = scope.querySelector('[data-cart-terms-checkbox]');
    if (!checkbox || checkbox.checked) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    showError(scope);
    checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (e.target.matches('form[action="/checkout"]')) {
        blockIfUnchecked(e, e.target);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.matches('button[name="checkout"]')
        ? e.target
        : e.target.closest('button[name="checkout"]');
      if (btn) blockIfUnchecked(e, btn);
    },
    true
  );

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-terms-checkbox]') && e.target.checked) {
      hideError(getScope(e.target));
    }
  });
})();
